<template>
  <section class="partner-products py20 new-collection container px15" v-if="products.length || (loading && skeleton)">
    <div>
      <header class="col-md-12">
        <h4 class="align-left cl-accent mt0">
          {{ title }}
        </h4>
      </header>
    </div>
    <div class="partner-products__row row center-xs">
      <product-listing-related
        v-if="products.length"
        columns="4"
        :products="products"
        :config="sliderConfig"
      />
      <product-listing-skeleton v-else :count="slidesLg" />
    </div>
  </section>
</template>

<script>
import ProductListingRelated from 'theme/components/core/ProductListingRelated'
import ProductListingSkeleton from 'theme/components/core/ProductListingSkeleton'

const BREAKPOINT_LG = 1199
const BREAKPOINT_MD = 1024
const BREAKPOINT_SM = 767
const SLIDES_LG = 6
const SLIDES_MD = 4
const SLIDES_SM = 3
const SLIDES_XS = 2

const slidesAt = slides => ({ slidesToShow: slides, slidesToScroll: slides, arrows: false })

export default {
  name: 'PartnerProductsSection',
  components: {
    ProductListingRelated,
    ProductListingSkeleton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    skeleton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      slidesLg: SLIDES_LG,
      sliderConfig: {
        ...slidesAt(SLIDES_LG),
        paginationEnabled: false,
        infinite: false,
        draggable: true,
        cssEase: 'ease-out',
        speed: 500,
        responsive: [
          { breakpoint: BREAKPOINT_LG, settings: slidesAt(SLIDES_MD) },
          { breakpoint: BREAKPOINT_MD, settings: slidesAt(SLIDES_SM) },
          { breakpoint: BREAKPOINT_SM, settings: slidesAt(SLIDES_XS) }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/grid';

$slides-lg: 6;
$slides-md: 4;
$slides-sm: 3;
$slides-xs: 2;

$row-height-lg: 310px;
$row-height-md: 355px;
$row-height-sm: 435px;
$row-height-xs: 370px;

$card-gutter: 8px;

.partner-products {
  &__row {
    min-height: $row-height-lg;
  }

  ::v-deep .product-listing {
    min-height: 0;
  }

  ::v-deep .product.collection-product {
    padding: 0 $card-gutter;
  }

  ::v-deep .collection-product {
    .product-link {
      display: block;
    }

    .product-image {
      height: auto;
      max-height: none;
      will-change: opacity;

      img {
        max-width: 100%;
        max-height: 100%;
        height: auto;
        vertical-align: bottom;
      }
    }
  }

  ::v-deep .product-listing-skeleton__item {
    flex: 0 0 percentage(1 / $slides-lg);
    max-width: percentage(1 / $slides-lg);
    padding: 0 $card-gutter;
    box-sizing: border-box;

    .placeholder {
      width: 100%;
      height: auto;
    }
  }

  @media #{$media-to-md} {
    .partner-products__row {
      min-height: $row-height-md;
    }

    ::v-deep .product-listing-skeleton__item {
      flex-basis: percentage(1 / $slides-md);
      max-width: percentage(1 / $slides-md);

      &:nth-of-type(n + #{$slides-md + 1}) {
        display: none;
      }
    }
  }

  @media #{$media-to-sm} {
    .partner-products__row {
      min-height: $row-height-sm;
    }

    ::v-deep .slick-button {
      display: none;
    }

    ::v-deep .product-listing-skeleton__item {
      flex-basis: percentage(1 / $slides-sm);
      max-width: percentage(1 / $slides-sm);

      &:nth-of-type(n + #{$slides-sm + 1}) {
        display: none;
      }
    }
  }

  @media #{$media-xs} {
    .partner-products__row {
      min-height: $row-height-xs;
    }

    ::v-deep .product-listing-skeleton__item {
      flex-basis: percentage(1 / $slides-xs);
      max-width: percentage(1 / $slides-xs);

      &:nth-of-type(n + #{$slides-xs + 1}) {
        display: none;
      }
    }
  }
}
</style>
